import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: localStorage.getItem("theme"),
  layers: [],
  error: null,
};

// export const fetchKpiAsync = createAsyncThunk(
//   'pms/fetchKpis',
//   async () => {
//     const response = await kpiService.fetchKpi();
//     return response.data;
//   }
// );

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    changeTheme: (state, action) => {
      localStorage.setItem("theme", action.payload);
      state.theme = action.payload;
    },
    addLayer: (state, action) => {
      state.layers = [...state.layers, action.payload];
    },
    deleteLayer: (state, action) => {
      state.layers = [...state.layers].filter((l) => l.name !== action.payload);
    },
    changeVisibility: (state, action) => {
      const { name, visible } = action.payload;
      state.layers = [...state.layers].map((layer) => {
        if (layer.name === name) {
          layer.visible = visible ? true : false;
        }

        return layer;
      });
    },
    changeOpacity: (state, action) => {
      const { name, opacity } = action.payload;
      state.layers = state.layers.map((layer) => {
        if (layer.name === name) {
          layer.opacity = opacity;
        }

        return layer;
      });
    },
  },

  // extraReducers: (builder) => {
  //   builder
  //     .addCase(fetchKpiAsync.pending, (state) => {
  //       state.status = 'loading';
  //     })
  //     .addCase(fetchKpiAsync.fulfilled, (state, action) => {
  //       state.status = 'idle';
  //       state.data = [...action.payload];
  //     })
  //     .addCase(fetchKpiAsync.rejected, (state, action) => {
  //       state.status = 'rejected';
  //       state.error = action.payload;
  //     });
  // },
});

export const {
  addLayer,
  changeVisibility,
  changeOpacity,
  deleteLayer,
  changeTheme,
} = mapSlice.actions;

export default mapSlice.reducer;
